type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const FacebookActionLikeIcon = (props: Props) => {
  const {
    width = '20',
    height = '20',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M9 21h9.4a2 2 0 0 0 1.95-1.55l1.6-7A2 2 0 0 0 20 10h-5l.86-4.3A1.5 1.5 0 0 0 14.4 4l-1 .67L9 11v10zm0 0H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
        stroke={fillColor}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FacebookActionLikeIcon;
